module.exports = __webpack_public_path__ + "img/invalid-image.4eeb2a44.png";